import { useNavigate } from "react-router-dom";
import useUser from "./useUser";
import { useEffect } from "react";
import { HOME } from "../enums/UrlPaths";
import { ADMIN, EMPLOYEE } from "../enums/Roles";

export const useRedirectIfNotOwnClinic = (clinicId, skip = false) => {
  const { roles, currentClinic, isLoading } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading || skip) return;

    if (!roles.master && String(currentClinic?.id) !== String(clinicId)) {
      navigate(HOME);
    }
  }, [clinicId, skip, roles.master, currentClinic?.id, isLoading, navigate]);
};

//Hook accepts a list of roles that can we the page
//If the current users role is not in the roles list the user is redirected to the home page
export const useRedirectIfRoleNotSupported = (roles = []) => {
  const { currentRole, isLoading } = useUser();
  const navigate = useNavigate();
  const rolesKey = roles.join(","); 

  useEffect(() => {
    if (isLoading) return;
    if (!roles.includes(currentRole)) {
      navigate(HOME);
    }
  }, [currentRole, isLoading, rolesKey]);
};

const ADMIN_OR_EMPLOYEE_ROLES = [ADMIN, EMPLOYEE];

export const useRedirectIfNotAdminOrEmployee = () => {
  useRedirectIfRoleNotSupported(ADMIN_OR_EMPLOYEE_ROLES);
};